import { createStyles } from '@mui/styles';
import { APTheme } from '../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
    maintenanceContainer: {
        display: "flex",
        justifyContent: "center",
    },
    bodyWrapper: {
        width: "100%",
        padding: '9em 0 4em 0',
        [theme.breakpoints.down('lg')]: {
          padding: '6em 0 4em 0',
        },
    },
    bodyContent: {
        margin: 'auto',
        padding: '0 16px',
        maxWidth: '460px',
        textAlign: 'center',
        '& h4': {
            margin: '0 59px 20px',
            fontFamily: 'CircularStd',
            fontSize: '26px',
            fontWeight: 'bold',
            lineHeight: 1.31,
            letterSpacing: '-0.5px',
            color: '#4a4a4a'
        },
        '& p': {
            margin: '20px 0 0',
            fontFamily: 'CircularStd',
            fontSize: '16px',
            fontWeight: 'normal',
            lineHeight: 1.5,
            letterSpacing: 'normal',
            color: '#4a4a4a'
        }
    },
    iconWrapper: {
        width: '140px',
        height: '140px',
        margin: '40px auto',
        // padding: '38px 39px 39px 38px',
        border: 'solid 6px #cccccc',
        borderRadius: '50%',
        '& svg': {
            width: '63px',
            height: '63px',
            padding: '3.9px 3.9px 3.9px',
            marginTop: '35px'
        }
    }
});
